var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "divBox" },
    [
      _c(
        "el-card",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.loading,
              expression: "loading",
            },
          ],
          staticClass: "box-card",
          attrs: { shadow: "never" },
        },
        [
          _c(
            "div",
            { attrs: { slot: "header" }, slot: "header" },
            [
              _vm._v(" 今日经营 "),
              _c("span", { staticClass: "sub" }, [
                _vm._v("按核销发生的时刻统计，跨零点确认的单据算在确认那一天"),
              ]),
              _c(
                "el-button",
                {
                  staticClass: "fr",
                  attrs: { type: "text" },
                  on: { click: _vm.load },
                },
                [_vm._v("刷新")]
              ),
            ],
            1
          ),
          _c(
            "el-row",
            { staticClass: "stat-row", attrs: { gutter: 16 } },
            _vm._l(_vm.cards, function (item) {
              return _c("el-col", { key: "d" + item.key, attrs: { span: 6 } }, [
                _c("div", { staticClass: "stat" }, [
                  _c("div", { staticClass: "stat-label" }, [
                    _vm._v(_vm._s(item.label)),
                  ]),
                  _c("div", { staticClass: "stat-value" }, [
                    _vm._v(
                      _vm._s(
                        item.points
                          ? _vm.num(_vm.today[item.key])
                          : _vm.yuan(_vm.today[item.key])
                      )
                    ),
                  ]),
                  _c("div", { staticClass: "stat-desc" }, [
                    _vm._v(_vm._s(item.desc)),
                  ]),
                ]),
              ])
            }),
            1
          ),
        ],
        1
      ),
      _c(
        "el-card",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.loading,
              expression: "loading",
            },
          ],
          staticClass: "box-card mt16",
          attrs: { shadow: "never" },
        },
        [
          _c("div", { attrs: { slot: "header" }, slot: "header" }, [
            _vm._v("本月累计"),
          ]),
          _c(
            "el-row",
            { staticClass: "stat-row", attrs: { gutter: 16 } },
            _vm._l(_vm.cards, function (item) {
              return _c("el-col", { key: "m" + item.key, attrs: { span: 6 } }, [
                _c("div", { staticClass: "stat" }, [
                  _c("div", { staticClass: "stat-label" }, [
                    _vm._v(_vm._s(item.label)),
                  ]),
                  _c("div", { staticClass: "stat-value" }, [
                    _vm._v(
                      _vm._s(
                        item.points
                          ? _vm.num(_vm.month[item.key])
                          : _vm.yuan(_vm.month[item.key])
                      )
                    ),
                  ]),
                  _c("div", { staticClass: "stat-desc" }, [
                    _vm._v(_vm._s(item.desc)),
                  ]),
                ]),
              ])
            }),
            1
          ),
        ],
        1
      ),
      _c(
        "el-card",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.loading,
              expression: "loading",
            },
          ],
          staticClass: "box-card mt16",
          attrs: { shadow: "never" },
        },
        [
          _c("div", { attrs: { slot: "header" }, slot: "header" }, [
            _vm._v("待办与账户"),
          ]),
          _c(
            "el-row",
            { staticClass: "stat-row", attrs: { gutter: 16 } },
            [
              _c("el-col", { attrs: { span: 6 } }, [
                _c("div", { staticClass: "stat" }, [
                  _c("div", { staticClass: "stat-label" }, [
                    _vm._v("待确认核销"),
                  ]),
                  _c(
                    "div",
                    {
                      staticClass: "stat-value",
                      class: { warn: _vm.overview.pendingConfirm > 0 },
                    },
                    [
                      _vm._v(
                        " " + _vm._s(_vm.overview.pendingConfirm || 0) + " 笔 "
                      ),
                    ]
                  ),
                  _c(
                    "div",
                    { staticClass: "stat-desc" },
                    [
                      _vm._v(" 超时未确认会自动作废并把积分退回用户 "),
                      _vm.overview.pendingConfirm > 0
                        ? _c(
                            "el-button",
                            {
                              attrs: { type: "text" },
                              on: { click: _vm.goVerify },
                            },
                            [_vm._v("去核销台")]
                          )
                        : _vm._e(),
                    ],
                    1
                  ),
                ]),
              ]),
              _vm._l(_vm.accountCards, function (item) {
                return _c("el-col", { key: item.key, attrs: { span: 6 } }, [
                  _c("div", { staticClass: "stat" }, [
                    _c("div", { staticClass: "stat-label" }, [
                      _vm._v(_vm._s(item.label)),
                    ]),
                    _c("div", { staticClass: "stat-value" }, [
                      _vm._v(_vm._s(_vm.yuan(_vm.account[item.key]))),
                    ]),
                    _c("div", { staticClass: "stat-desc" }, [
                      _vm._v(_vm._s(item.desc)),
                    ]),
                  ]),
                ])
              }),
            ],
            2
          ),
          _c("div", { staticClass: "tips" }, [
            _vm._v(
              " 「今日应收」是当天新产生的，「可提现」是走完观察期已经能拿的，两者不是同一笔钱， 差额都还压在待核对与待结算里。 "
            ),
          ]),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }